import React, { Component } from 'react';
import './ScoreBoard.css';

class ScoreBoard extends Component {
  state = {
    scores: [{
      final: '',
      periods: [],
    }],
    status: '',
  }

  initializeProps = () => {
    const data = this.props.data.gamescore.boxscore;
    const info = data.gameinformation;
    
    const [away, home] = data.teamstats.map(item => (
      {'final': item.goals, 'periods': item.linescore.period }
    ));

    this.setState({
      scores:[
        away,
        home,
      ],
      status: info.gamestatus.status,
      away_mascot: info.awayteam.mascot,
      home_mascot: info.hometeam.mascot,
    })
  }

  componentDidMount = () => {
    this.initializeProps();
  }

  componentDidUpdate = (nextProps) => {
    if (this.props.data !== nextProps.data) {
      this.initializeProps();
    }
  }
      
  render() {
    return (
      <div className='scoreboard-container'>
        <div className='scoreboard-wrapper'>
          <div className='status site-background-color'>
            {this.state.status !== 'FINAL'? 
              <span className='live'>Live</span> :
              <span>Final</span>
            }
          </div>
          <table className='table-teams'>
            <tbody>
              <tr>
                <th></th>
              </tr>
              <tr>
                <td>{this.state.away_mascot}</td>
              </tr>
              <tr>
                <td>{this.state.home_mascot}</td>
              </tr>
            </tbody>
          </table>
        </div>
      <table className='table-scores'>
        <tbody>
          <tr>
            {this.state.scores[0].periods.map((scores, i) => (
              <th className='scoreboard-header' key={i}>{`P${i+1}`}</th>
            ))}
          </tr>
          {this.state.scores.map((scores, i) => (
            <tr key={i}>
              {scores.periods.map((item, ii) => (
                <td className='scoreboard-content' key={ii}>
                  <span>{item.goals}</span>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <table className='table-final'>
        <tbody>
          <tr>
            <th className='scoreboard-header'>FINAL</th>  
          </tr>
          {this.state.scores.map((item, i) => (
            <tr key={i}>
              <td className='scoreboard-content'>
                <span className='site-color'>{item.final}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    )
  }
}

export default ScoreBoard;